export default __webpack_public_path__ + "static/media/videoOn.412f3027.svg";